module.exports = __webpack_public_path__ + "img/videoTowerBaseline.6d2188d3.webp";